import { render, staticRenderFns } from "./MyBoard.vue?vue&type=template&id=0b13be42&scoped=true&lang=pug&"
import script from "./MyBoard.vue?vue&type=script&lang=ts&"
export * from "./MyBoard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b13be42",
  null
  
)

export default component.exports